export default __webpack_public_path__ + "static/media/aerial.ca706e6b.png";